import { Component } from '@angular/core';
import { DialogRef } from '@ds/ng-wt-dialog';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'ds-confirmation-alert-dialog',
  standalone: false,
  templateUrl: './confirmation-alert-dialog.component.html',
  styleUrl: './confirmation-alert-dialog.component.scss'
})
export class ConfirmationAlertDialogComponent {
  constructor(private dialogRef: DialogRef, private translocoService: TranslocoService) {}
  
  onButtonClick(buttonAction: string) {
    this.dialogRef.close(buttonAction);
  }

  get dialogTitle() {
    return this.dialogRef.data?.dialogTitle;
  }

  get dialogMessage() {
    return this.dialogRef.data?.dialogMessage;
  }

  get okButtonText() {
    return this.dialogRef.data?.okButtonText || this.translocoService.translate('MODULES.COMMON.OK');
  }
}
